module.exports = __webpack_public_path__ + "img/organization_illustration.b00f8b1e.svg";